import axios from 'axios';
import {KRBS_TONS, APP_TONS} from '../../config/constanst.config';
import {AlertService} from '../../service/alert.service';
import SecureLs from 'secure-ls';
import CryptoJs from 'crypto-js';
import {AppService} from '../../service/app.service';


/** state **/
const state = {
  authUser: {},
  authPos: {},
  authFormData: {
    logAs: null, username: null, password: null,
  },
  authUserSystems: [],
};

/** mutations **/
const mutations = {
  set_auth_user(state, payload) {
    state.authUser = payload?.authUser;
    state.authPos = payload?.authPos;
    state.authUserSystems = payload?.authUserSystems;

    let token = payload?.token;

    const encryptTokenKey = CryptoJs.AES.encrypt(token, APP_TONS.ENCRYPTED_SECRET).toString();
    localStorage.setItem(APP_TONS.TOKEN, encryptTokenKey);
  },

  reset_auth_form_data(state) {
    state.authFormData = {
      logAs: null, username: null, password: null,
    };
  },

  set_logout_auth(state) {
    window.localStorage.clear();
    window.localStorage.removeItem('vuex-tons')
    state.authUser = {};
    state.authPos = {};
    state.authUserSystems = [];
  },
};

/** actions **/
const actions = {
  async login({commit}, payload) {
    commit('set_is_loading', true);
    return await axios.post(KRBS_TONS.LOGIN, payload).then((r) => {
      // console.log(r.data);
      commit('set_is_loading', false);
      commit('set_auth_user', r.data);
      commit('reset_auth_form_data');
      commit('set_crew_ton_id',r.data.crewTonId)
      AlertService.successAlertService('User login successfully', 'Login');
      return true;

    }).catch((e) => {
      commit('set_is_loading', false);
      AlertService.responseAlertMessage(e, 'Log in');
      return false;

    });
  },

  async logOut({commit}) {
    let authPos = AppService.originalState('auth','authPos')
    let logOutUrl = null;

    switch (authPos.id) {
      case 2:
        logOutUrl = KRBS_TONS.USER_LOGOUT;
        break;

      case 1:
      case 3:
      case 4:
        logOutUrl = KRBS_TONS.STAFFS_LOGOUT;
        break;

      case 5:
        logOutUrl = KRBS_TONS.CREW_LOGOUT;
        break;
    }

    return axios.post(logOutUrl).then((r) => {
      commit('set_logout_auth');
      commit('reset_key_objects');
      return true;

    }).catch((er) => {
      AlertService.responseAlertMessage(er, 'Logout');
      return false;

    });
  },

  reset_auth_form_data({commit}) {
    commit('reset_auth_form_data');
  },

  async changePassword({commit}, payload) {
    let authPos = AppService.originalState('auth','authPos')
    let userPrefix = null;
    switch (authPos.id) {
      case 2:
        userPrefix = KRBS_TONS.USER_CHANGE_PASS;
        break;

      case 1:
      case 3:
      case 4:
        userPrefix = KRBS_TONS.STAFF_CHANGE_PASS;
        break;
    }
    return axios.post(userPrefix, payload).then((r) => {
      AlertService.successAlertService('Successfully change password','Password Change')
      return true;
    }).catch((er) => {
      AlertService.responseAlertMessage(er, 'Change Password');
      return false;
    });
  },
};

/** getters **/
const getters = {
  demo: (state) => state.demo,
  authUser: (state) => state.authUser,
  authPos: (state) => state.authPos,
  authFormData: (state) => state.authFormData,
  authUserSystems: (state) => state.authUserSystems,
};

/** export **/
export default {state, actions, mutations, getters};
